import InputWithDetails, {
  type InputWithDetailsPropsType,
} from "./InputWithDetails"

export type RadioWithDetailsPropsType = InputWithDetailsPropsType

const RadioWithDetails = (props: RadioWithDetailsPropsType) => (
  <InputWithDetails {...props} type="radio" />
)

export default RadioWithDetails
